import { useAtom } from '@reatom/npm-react'
import styled, { css } from 'styled-components'

import { tradesPausedAtom } from '@root/features/trade/tables/trades-table'
import { mediaMaxDesktopSmall, PausedBadge } from '@root/shared/ui-kit'
import { TradeTablesActionsTrade } from '@root/widgets/instant-trade-dialog/ui/trade-tables-actions-trade'
import {
  PathfinderDebugButton,
  PathfinderDebugDialog,
} from '@root/widgets/pathfinder-debug-dialog'

import { ToggleTradesViewOptionButton } from './toggle-trades-view-option'
import { TradeTablesActionsComment } from './trade-tables-actions-comment'

export const TradeTablesActions: React.FC = () => {
  const [paused] = useAtom(tradesPausedAtom)

  return (
    <Root>
      {paused ? (
        <PausedBadge paused={paused} textCss={PausedBadgeCss} />
      ) : undefined}
      <TradeTablesActionsTrade />
      <PathfinderDebugButton />
      <ToggleTradesViewOptionButton />
      <Left>
        <TradeTablesActionsComment />
      </Left>
      <PathfinderDebugDialog />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  justify-content: end;
  align-items: center;
  align-content: center;
  grid-auto-flow: column;

  gap: 8px;
`
const Left = styled.div`
  display: flex;
`

const PausedBadgeCss = mediaMaxDesktopSmall(css`
  display: none;
`)
